module.exports = __webpack_public_path__ + "img/help_forward.228d66fe.svg";